module.exports = __webpack_public_path__ + "img/COBRA Millenial Infographic.7c3098ab.png";